/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.slideshow = this.querySelector('slide-show');
      this.currentId = this.dataset.productHandle;
      this.max = 10;
      this.products = '';
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof(recentIds) !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }
    connectedCallback() {
      // KL (live review F7, 20 Sep 2026): a first-time visitor has no history, so the section
      // used to print its heading and two dead arrows over nothing (and the empty carousel threw
      // the six clientHeight errors, F8). No history -> the whole section disappears.
      const ids = Array.isArray(window.recentlyViewedIds) ? window.recentlyViewedIds.filter(v => v !== this.currentId) : [];
      if (!ids.length) {
        const section = this.closest('.shopify-section') || this.closest('.recently-viewed-products') || this;
        section.style.display = 'none';
        return;
      }
      this.buildUrl();
    }
    buildUrl() {
      let i = 0;
      let handles = [];
      
      window.recentlyViewedIds.forEach((val) => {
        if (val === this.currentId) {
          return;
        }
        if (i >= this.max) {
          return;
        }
        handles.push(val);
        this.products += 'handle:' + val + ' OR ';
        i++;
      });

      this.url = this.url + encodeURIComponent(this.products);
      this.orderedHandles = handles;

      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            const productItems = Array.from(recommendations.querySelectorAll('li'));
            const orderedProducts = [];
            
            this.orderedHandles.forEach(handle => {
              const product = productItems.find(item => {
                const link = item.querySelector('a[href*="/products/"]');
                return link && link.href.includes('/products/' + handle);
              });
              if (product) {
                // Wrap each <li> in a div with carousel__slide class to match the theme's pattern
                const wrapper = document.createElement('div');
                wrapper.className = 'small-6 medium-4 large-2 columns carousel__slide';
                wrapper.appendChild(product.cloneNode(true));
                orderedProducts.push(wrapper);
              }
            });
            
            // Save the navigation buttons before clearing
            const prevButton = this.slideshow.querySelector('.flickity-prev, .flickity-nav.flickity-prev');
            const nextButton = this.slideshow.querySelector('.flickity-next, .flickity-nav.flickity-next');
            
            // Clear the slideshow
            this.slideshow.innerHTML = '';
            
            // Re-add the buttons FIRST
            if (prevButton) this.slideshow.appendChild(prevButton);
            if (nextButton) this.slideshow.appendChild(nextButton);
            
            // Then add the products
            orderedProducts.forEach(product => {
              this.slideshow.appendChild(product);
            });
            
            this.classList.add('product-recommendations--loaded');
            
            // Set up BUY NOW button redirect functionality (copied from product-recommendations)
            this.setupBuyNowRedirect();
            
            // CRITICAL: Refresh Flickity after products are loaded
            // Wait a moment for DOM to settle, then trigger Flickity refresh
            setTimeout(() => {
              // Check if Flickity instance exists on the slideshow
              if (this.slideshow.flickityInstance) {
                // Destroy and reinitialize
                this.slideshow.flickityInstance.destroy();
              }
              
              // Trigger the slide-show to reinitialize by dispatching a custom event
              // or by manually calling the constructor again
              const event = new Event('slideshow:refresh');
              this.slideshow.dispatchEvent(event);
              
              // Alternative: Force reflow and let slide-show reinitialize
              this.slideshow.dataset.initiated = 'false';
              
              // Manually trigger Flickity initialization
              if (typeof Flickity !== 'undefined') {
                const flkty = new Flickity(this.slideshow, {
                  wrapAround: false,
                  cellAlign: 'left',
                  pageDots: false,
                  contain: true,
                  prevNextButtons: false,
                  cellSelector: '.carousel__slide'
                });
                
                // Hook up the buttons
                if (prevButton) {
                  prevButton.addEventListener('click', () => flkty.previous(true));
                }
                if (nextButton) {
                  nextButton.addEventListener('click', () => flkty.next(true));
                }
                
                // Store reference
                this.slideshow.flickityInstance = flkty;
              }
            }, 100);
          }

        })
        .catch(e => {
          console.error(e);
        });
    }
    
    setupBuyNowRedirect() {
      // First, disable any quick view triggers in the recently viewed section
      const quickViewTriggers = this.querySelectorAll('.quick-view-trigger, [data-quick-view-trigger], .quick-add, .quick-shop, .quick-add-button, quick-view');
      quickViewTriggers.forEach(trigger => {
        // Remove existing event listeners by cloning and replacing
        const newTrigger = trigger.cloneNode(true);
        trigger.parentNode.replaceChild(newTrigger, trigger);
        // Hide these elements for certainty
        newTrigger.style.display = 'none';
      });
      
      // Target all "BUY NOW" buttons and links in recently viewed products
      const buyButtons = this.querySelectorAll('.button, .btn, a.button, button.button, a[href*="options"]');
      
      buyButtons.forEach(button => {
        // Remove existing event listeners by cloning and replacing
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
        
        // Add our new click handler
        newButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation(); // Stop event from bubbling up
          
          // Get product URL from closest product card
          const productCard = this.closest('.product-card') || this.closest('.card') || this.closest('li');
          if (!productCard) return;
          
          const productLink = productCard.querySelector('a[href*="/products/"]');
          if (productLink) {
            window.location.href = productLink.href;
          }
        }, true); // Use capturing instead of bubbling
      });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}